/**
 * Generates a delete operation script for CRUD tools
 */

/**
 * Generates a delete operation script
 */
export function generateDeleteScript(): string {
    return String.raw`(function (inputs) {


    // parses query expression containing {{variables}}
    // by replacing {{variableName}} with the value of the variableName property in the inputs object
    // if the variableName property is not found in the inputs object, the variableName is returned as is
    function parseQuery(expression, inputs) {
        if (!expression) return '';
        return expression.replace(
            /{{\s*(\w+)\s*}}/g,
            function (match, variableName) {
                if (inputs && inputs.hasOwnProperty(variableName)) {
                    return inputs[variableName];
                }
                return match;
            }
        );
    }


    // Helper function to log deletion failures
    function logDeletionFailure(recordId, query) {
        gs.error(
            '[AIA error] record not deleted: ' + recordId + ' from the encoded query: ' + query
        );
    }


    const table = inputs.crudInputs.table.value;
    const tableName = inputs.crudInputs.table.displayValue;
    const query = parseQuery(inputs.crudInputs.query, inputs);


    let protectedRecords = 0;
    let deletedRecords = 0;


    const gr = new GlideRecordSecure(table);
    if (query) {
        gr.addEncodedQuery(query, true);
    } else {
        gs.error('[AIA error] No query provided');
        return {
            message: 'No query provided',
            status: sn_i18n.Message.getMessage('sn_aia', 'error'),
        };
    }


    gr.query();
    while (gr.next()) {
        if (gr.canDelete()) {
            if (gr.deleteRecord()) {
                deletedRecords++;
            } else {
                logDeletionFailure(gr.getUniqueValue(), query);
                protectedRecords++;
            }
        } else {
            logDeletionFailure(gr.getUniqueValue(), query);
            protectedRecords++;
        }
    }
    const total = deletedRecords + protectedRecords;
    const message = sn_i18n.Message.getMessage(
        'sn_aia',
        '{count} out of {total} records deleted from the {table} table.',
        {
            count: deletedRecords.toString(),
            total: total.toString(),
            table: tableName,
        }
    );


    const status =
        deletedRecords === total
            ? sn_i18n.Message.getMessage('sn_aia', 'success')
            : sn_i18n.Message.getMessage('sn_aia', 'error');


    return {
        deletedRecords: deletedRecords,
        message: message,
        status: status,
    }; 
})(inputs);`
}
